export default __webpack_public_path__ + "static/media/CASSIE_Ferramenta.193742dc.png";